import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">探索你喜欢的漫画类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 bg-background-50 rounded-lg border border-background-200 hover:border-primary-300 hover:shadow-sm transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">
                {cat.count}部
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}